export const STATUS_CHIP_CONFIG: Record<
  string,
  { label: string; color: 'info' | 'success' | 'error' | 'warning' | 'default' }
> = {
  // Active / in-progress
  Prospecting: { label: 'Prospecting', color: 'info' },
  Open: { label: 'Open', color: 'info' },
  Planned: { label: 'Planned', color: 'info' },
  'Connectivity review': { label: 'Connectivity Review', color: 'info' },
  'Proposal Sent': { label: 'Proposal Sent', color: 'info' },
  'Proposal Negotiation': { label: 'Proposal Negotiation', color: 'info' },
  'Partner Engaged': { label: 'Partner Engaged', color: 'info' },
  'Extranet Discount Notification': { label: 'Notification Sent', color: 'info' },
  // Paused / needs attention
  'On Hold': { label: 'On Hold', color: 'warning' },
  'Extranet Notification Not Actioned': { label: 'Not Actioned', color: 'warning' },
  // Positive terminal
  'Closed Won': { label: 'Won', color: 'success' },
  'Signed Contract': { label: 'Signed Contract', color: 'success' },
  'Review Extranet Discount Added': { label: 'Discount Added', color: 'success' },
  // Negative terminal
  Lost: { label: 'Lost', color: 'error' },
  Withdrawn: { label: 'Withdrawn', color: 'error' },
};

export const PROPERTY_SCORE_CATEGORY_CHIP: Record<
  string,
  { label: string; color: 'info' | 'success' | 'error' | 'warning' | 'default' }
> = {
  'Good state': { label: 'Good', color: 'success' },
  'Official site undercut': { label: 'Official Undercut', color: 'error' },
  'Partner Offer Beating Us': { label: 'Partner Beating Us', color: 'error' },
  'Parity Issue not resolved': { label: 'Unresolved', color: 'warning' },
  'Data quality attention': { label: 'Data Quality', color: 'default' },
  'Not conclusive': { label: 'Not Conclusive', color: 'default' },
};
